import React, { useEffect } from "react";

const APPLE_CLIENT_ID = "com.supportedbusiness.chatlogin";

const AppleLoginPopup: React.FC = () => {
  useEffect(() => {
    // Immediately redirect to Apple OAuth URL for authorization code flow
    const redirectUri = "https://webchat.supportedbusiness.com/auth/callback";
    const urlParams = new URLSearchParams(window.location.search);
    const clientId = urlParams.get("clientId") || "";
    const mode = urlParams.get("mode") || "login";
    const dateOfBirth = urlParams.get("dateOfBirth") || "";
    
    // Store in localStorage for the callback to use
    localStorage.setItem('ClientID', clientId);
    localStorage.setItem('OAuthMode', mode);
    localStorage.setItem('OAuthDateOfBirth', dateOfBirth);

    const authUrl = new URL("https://appleid.apple.com/auth/authorize");
    authUrl.searchParams.set("client_id", APPLE_CLIENT_ID);
    authUrl.searchParams.set("redirect_uri", redirectUri);
    authUrl.searchParams.set("response_type", "code id_token");
    authUrl.searchParams.set("scope", "name email");
    authUrl.searchParams.set("response_mode", "form_post");
    authUrl.searchParams.set("state", "apple_login"); // Add state parameter for identification

    // Debug logs for troubleshooting
    console.log("[AppleLoginPopup] APPLE_CLIENT_ID:", APPLE_CLIENT_ID);
    console.log("[AppleLoginPopup] redirectUri:", redirectUri);
    console.log("[AppleLoginPopup] ClientID:", clientId);
    console.log("[AppleLoginPopup] Mode:", mode);
    console.log("[AppleLoginPopup] OAuth URL:", authUrl.toString());

    // Redirect to Apple OAuth consent screen
    window.location.href = authUrl.toString();
  }, []);

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #000 0%, #333 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: 16,
          boxShadow: "0 4px 24px rgba(0,0,0,0.20)",
          padding: "40px 32px 32px 32px",
          minWidth: 340,
          maxWidth: 400,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {/* Apple Logo */}
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" style={{marginBottom: 16}}>
          <rect width="48" height="48" rx="12" fill="#000"/>
          <path d="M30.5 15.5c.8-1 1.3-2.4 1.2-3.8-1.2.1-2.6.8-3.5 1.8-.8.9-1.5 2.3-1.3 3.7 1.4.1 2.8-.7 3.6-1.7zM32.8 19.3c-1.8-1-3-2.8-2.7-4.5 1.6 0 3.2.9 4.2 2.3.8 1.1 1.3 2.6 1.1 4-.1 0-2.6 1.2-2.6 3.8 0 3 2.6 4 2.7 4.1-.1.2-.4 1.4-1.4 2.8-.9 1.2-1.8 2.4-3.2 2.4s-1.8-.8-3.4-.8-2.1.8-3.4.8-2.2-1.1-3.2-2.4c-2.1-2.9-3.7-8.2-1.5-11.8 1.1-1.8 3-2.9 5.1-2.9 1.6 0 2.9.8 3.9.8s2.4-.8 4.1-.8c.7 0 3.2.3 4.7 2.2-.1.1-2.8 1.6-2.8 4.8z" fill="#fff"/>
        </svg>
        
        <h2 style={{ color: "#000", margin: 0, fontWeight: 700, fontSize: 24, letterSpacing: 0.5 }}>Redirecting to Apple...</h2>
        <p style={{ color: "#666", margin: "12px 0 24px 0", fontSize: 15, textAlign: "center" }}>
          Please wait while we redirect you to Apple for secure authentication.
        </p>
        
        {/* Loading spinner */}
        <div style={{
          width: 40,
          height: 40,
          border: "4px solid #f3f3f3",
          borderTop: "4px solid #000",
          borderRadius: "50%",
          animation: "spin 1s linear infinite"
        }} />
        
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    </div>
  );
};

export default AppleLoginPopup;
